import sanitizeUrl from 'utils/sanitize-url';

/**
 * Build a safe, human-readable descriptor of an image source for error
 * reporting.
 *
 * `loadImage` used to log `typeof input` in its Bugsnag metadata, so every
 * "Could not load the image" event recorded `"src": "string"` and nobody could
 * tell *which* images were failing. For URL strings this delegates to
 * `sanitizeUrl`, which strips credentials, the query/hash and inline `data:`
 * payloads; `File` inputs are described by type and size, never the filename.
 *
 * @param input The value passed to `loadImage` — a URL string or a `File`.
 * @returns A short descriptor safe to attach to an error report.
 */
export default function describeImageSource(input: string | File): string {
	if (typeof input !== 'string') {
		return `File(type=${input.type || 'unknown'}, size=${input.size})`;
	}

	return sanitizeUrl(input);
}
